"use strict";

import Vue from 'vue';
import axios from "axios";
import store from "@/store";
import router from '../router';
import { IMPROVE_CONFIG } from "@/config.js";

const token = localStorage.getItem("token");
const UNAUTHORIZED = 401;
const isAuthenticated = store.getters.isLoggedIn;

Vue.prototype.$axios = axios;

axios.defaults.baseURL = IMPROVE_CONFIG.API_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

// The global request deadline. This used to sit in src/api/channel.js as an
// import side effect whose comment read "3 seconds" while the value was
// 300000ms - five minutes. Moved here, where every api/*.js module reads it:
// they all use the bare axios export, not the _axios instance created below.
//
// Left at 300s ON PURPOSE. Large SCORM and file uploads share this default and
// a tighter ceiling would start failing them. It is a backstop against a dead
// socket, not a UX budget - screens that must not wait this long race their
// own deadline, as OnboardingWizard.vue's bootstrap() does.
axios.defaults.timeout = 300000;

if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

let config = {
  baseURL: IMPROVE_CONFIG.API_URL,
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    // error.response is undefined for a timeout, a dropped connection or a
    // CORS failure. Destructuring it threw a TypeError from inside the error
    // handler, replacing the real cause with a misleading one.
    const status = error.response && error.response.status;
    if (isAuthenticated && status === UNAUTHORIZED) {
      store.dispatch("logout");
      router.push("/login");
    }
    return Promise.reject(error);
  }
);


axios.interceptors.response.use(
  response => response,
  error => {
    // error.response is undefined for a timeout, a dropped connection or a
    // CORS failure. Destructuring it threw a TypeError from inside the error
    // handler, replacing the real cause with a misleading one.
    const status = error.response && error.response.status;
    if (store.getters.isLoggedIn && status === UNAUTHORIZED) {
      store.dispatch("logout");
      router.push("/login");
    }
    return Promise.reject(error);
  }
);
// Plugin.install = function(Vue, options) {  

Plugin.install = function(Vue) {  
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
